/**
 * c-card-atc.js
 *
 * Shared add-to-cart behaviour for the `c-product-card` snippet. Cards render
 * a plain product form that posts to the cart, so everything still works
 * without JavaScript; this script upgrades the submit to an AJAX add that
 * opens the cart drawer instead of navigating away.
 *
 * The add itself is delegated to `window.FM.cart` (see `c-cart-drawer.js`) so
 * there is one entry point into the cart rather than a second fetch that the
 * drawer then has to notice.
 *
 * Installs a single delegated listener no matter how many sections load it.
 */
(function () {
  if (window.__cCardAtcReady) return;
  window.__cCardAtcReady = true;

  document.addEventListener('submit', function (event) {
    /* Apps on this store dispatch synthetic events targeting `document`, which
       has no `closest`. */
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var form = target.closest('form[data-c-card-atc]');
    if (!form) return;

    var cart = window.FM && window.FM.cart;
    /* No drawer on the page: let the browser post the form and land on /cart. */
    if (!cart) return;

    event.preventDefault();

    var button = form.querySelector('[data-c-card-atc-btn]');
    var restore = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = button.getAttribute('data-adding-label') || restore;
    }

    cart
      .addForm(form)
      .then(function () {
        if (button) {
          button.disabled = false;
          button.textContent = restore;
        }
      })
      .catch(function (error) {
        if (button) {
          button.disabled = false;
          button.textContent = (error && error.message) || restore;
        }
      });
  });
})();
